/* eslint-disable no-prototype-builtins */
<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import api from '@/api'

  export default {
    name: 'NewsPage',
    metaInfo() {
      return {
        title: this.newsItem ? this.newsItem.title : '',
      }
    },
    components: {
      CTA: () => import('@/components/modules/CTA'),
      NewsIntro: () => import('@/components/modules/NewsIntro'),
    },
    data() {
      return {
        openedPanel: null,
        hoverLike: false,
        hoverComment: false,
        isArticle: false,
        commentClicked: false,
        comments: {
          isPending: false,
          data: {},
        },
        likes: {
          isPending: false,
          data: {},
        },
      }
    },
    computed: {
      ...mapState('news', ['newsItem']),
    },
    watch: {
      '$route.params.id'(value) {
        this.getNewsItem(value)
      },
      openedPanel(val) {
        this.commentClicked = val === 'comments'
      },
    },
    created() {
      this.getNewsItem(this.$route.params.id).then(_ => {
        this.isArticle = this.newsItem.meta && this.newsItem.meta.type && this.newsItem.meta.type === 'article'

        if (!Object.prototype.hasOwnProperty.call(this.newsItem, 'likes_allowed') || this.newsItem.likes_allowed) {
          this.fetchLikes()
        }
        if (this.newsItem.comments_allowed) {
          this.fetchComments()
        }
      })
    },
    methods: {
      ...mapActions('news', ['getNewsItem']),
      ...mapActions('posts', [ 'deleteComment' ]),
      toggleState(state) {
        state = !state
      },
      fetchComments() {
        this.toggleState(this.comments.isPending)
        api.items.getItems('comments', { type: 'news', id: this.newsItem.id }).then(({ data }) => {
          this.comments.data = data
          this.toggleState(this.comments.isPending)
        })
      },
      fetchLikes() {
        this.toggleState(this.likes.isPending)
        api.items.getItems('likes', { type: 'news', id: this.newsItem.id }).then(({ data }) => {
          this.likes.data = data
          this.toggleState(this.likes.isPending)
        })
      },
      onLike(val) {
        this.toggleState(this.likes.isPending)
        api.items.editItem('likes', { type: 'news', id: this.newsItem.id, like: val }).then(({ data }) => {
          this.likes.data = data
          this.toggleState(this.likes.isPending)
        })
      },
      onComment(val) {
        this.toggleState(this.comments.isPending)
        api.items.editItem('comments', { type: 'news', id: this.newsItem.id, like: val }).then(({ data }) => {
          this.comments.data = data
          this.toggleState(this.comments.isPending)
        })
      },
      togglePanel(val) {
        this.openedPanel = this.openedPanel === val ? null : val
        this.$nextTick(() => {
          const elem = document.querySelector('.cta-panel')
          if (elem) {
            elem.scrollIntoView()
          }
        })
      },
      onDeleteComment(data) {
        this.deleteComment(data.selectedCommentId).then(_ => {
          api.items.getItems('comments', { type: 'news', id: data.postId }).then(({ data }) => {
            this.comments.data = data
          })
        })
      },
    },
  }
</script>
